export default "__VITE_ASSET__DWtgfiYU__"